export default {
	translation: {
		nav: {
			happyGraduation: 'Open 24 hours, 7 days a week, 365 days a year.',
			happyGraduationMobile: 'Always Open.',
		},
		head: {
			title: `Peep Show Revival`,
			metaDescription: `A private viewing apparatus.`,
			metaKeywords: `peep show history, mutoscope, penny arcade, vintage viewing cabinet, 19th century peep show, mechanical viewing machine, coin operated viewer, early cinema apparatus, nickelodeon era entertainment, private exhibition cabinet, arcade cabinet viewing`,
		},
		cover: {
			header1: `Feed the Hungry Slot and`,
			header2: `Turn your crank!`,
			peepShowTop: `PRIVATE`,
			peepShowBottom: `ACCESS`,
			patent1: 'FEATURE',
			patent2a: 'Viewed',
			patent2b: 'times',
			manufacturer: 'Bratags',
			location: 'WORLDWIDE',
            inflation: `Adjusted for inflation <span class="text-green-darken-4 font-weight-bold">{{amount}}</span> in {{year}} is the same as <span class="text-green-darken-4 font-weight-bold">10c</span> was in the 1970's when peep shows became popular.<p class="mt-2">Still a small price to pay for a private viewing experience!</p>`,
		},
        warning: {
			header1: `This is an adult website`,
			header2: '',
			peepShowTop: `18+ ONLY`,
			enter: 'I am 18 or older - Enter',
            exit: 'I am under 18 - Exit',
			notice: 'This website contains age-restricted materials including nudity and explicit depictions of sexual activity. By entering, you affirm that you are at least 18 years of age or the age of majority in the jurisdiction you are accessing the website from and you consent to viewing sexually explicit content.',
		},
        upload: {
            form: {
                description: 'Tell the world what your show is about.',
                secondaryDescription: 'And the secondary content...',
            }
        },
		/* prettier-ignore */
		wips1: [
            `See things you've never seen.`,
            `A private exhibition awaits.`,
            `Step up to the cabinet.`,
            `What happens behind the peephole stays there.`,
            `A glance is all it takes.`,
            `Curiosity rewarded.`,
            `Witness the unseen.`,
            `Some things were never meant for the crowd.`,
            `Look closer.`,
            `Every viewing tells a story.`,
        ],
		wips2: [
			`Insert coin. Turn crank. Witness.`,
			`Step into the cabinet.`,
			`Feed the slot and see what happens.`,
			`One coin. One viewing.`,
			`A modern mutoscope.`,
			`The cabinet is waiting.`,
			`Engage the mechanism.`,
			`Private viewing, just like the old arcades.`,
			`Turn the crank and take a peek.`,
			`A new spin on a timeless curiosity.`,
		],
		wips3: [
            `No accounts. No feeds. Just a look.`,
            `Your viewing is your own.`,
            `Discreet. Direct. Private.`,
            `Some shows are meant for one set of eyes.`,
            `The most personal way to watch.`,
            `No crowd. No noise.`,
            `Step inside and shut the door.`,
            `A moment meant only for you.`,
        ],
		wips4: [
            `Insert crypto instead of coins.`,
            `Every view pays the creator.`,
            `No middlemen. No subscriptions.`,
            `Direct support, one view at a time.`,
            `Crypto makes the cabinet work again.`,
            `Creators paid for every peek.`,
            `A coin for curiosity.`,
            `Pay once. View once.`
        ],
		wips5: [
            `Get paid directly for <span class="font-weight-bold mx-1">EVERY SINGLE</span> view.`,
            `Creators deserve the whole coin.`,
            `Every crank counts.`,
            `Your curiosity powers creators.`,
            `Independent shows deserve independent pay.`,
            `One view. One payment.`,
            `No platform taking the cut.`,
            `A cabinet built for creators.`,
            `Support what you see.`
        ],
		wips6: [
            `The peep show returns.`,
            `Inspired by penny arcades of the past.`,
            `A digital mutoscope for the modern age.`,
            `Yesterday's curiosity, rebuilt for today.`,
            `The cabinet lives again.`,
            `An old tradition, reimagined.`,
            `The art of the peek.`,
            `History repeats itself.`,
            `From penny arcades to crypto wallets.`
        ],
		wips7:[
            `Take a peek.`,
            `Curiosity welcomed.`,
            `Look inside.`,
            `Just one view.`,
            `Private exhibition.`,
            `Coin required.`,
            `Step closer.`,
            `The show begins here.`
        ],
	},
}
